import {ConnectedPosition} from '@angular/cdk/overlay';
import {PeriodMode, RecentUnit} from './period-selector9';

/** What the backend expects. Matches the legacy selector's contract. */
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const TIME_FORMAT = 'HH:mm';

/** Shown greyed while a timeframe endpoint is unset, and what an unset one resolves to. */
export const DEFAULT_START_TIME = '00:00';
export const DEFAULT_END_TIME = '23:59';

/** Typed dates tolerated in either profile, most canonical first — the first format that parses wins. */
export const DATE_INPUT_FORMATS = ['YYYY.MM.DD', 'YYYY.MM.DD.', 'YYYY.M.D', 'YYYY-MM-DD', 'YYYY/MM/DD', 'YYYYMMDD'];

/**
 * Also tolerated in the US profile, ahead of {@link DATE_INPUT_FORMATS}: what the field shows
 * (`Sep 16`, `Dec 31, 2025`) and the common US spellings. The year-less ones mean the current year.
 * Month-first `M/D` is US only — elsewhere a slashed date reads day-first.
 */
export const US_DATE_INPUT_FORMATS = ['MMM D', 'MMM D, YYYY', 'MMM D YYYY', 'M/D', 'M/D/YYYY'];

export const MODE_LABELS: Record<PeriodMode, string> = {
  all: $localize`All Time`,
  day: $localize`Day`,
  range: $localize`Range`,
  recent: $localize`Recent`,
};

export const RECENT_UNIT_LABELS: Record<RecentUnit, string> = {
  hours: $localize`hours`,
  days: $localize`days`,
  weeks: $localize`weeks`,
  months: $localize`months`,
};


export const DATE_PICKER_POSITIONS: ConnectedPosition[] = [
  {originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 0},
  {originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetX: 0, offsetY: 0},
  {originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: 0},
  {originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetX: 0, offsetY: 0},
];
